import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  ExclamationCircleFilled,
  EyeInvisibleOutlined,
  EyeOutlined,
  LockOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import { Button, Dropdown, Space, Tag, Tooltip } from "antd";
import { DotVerticalIcon, UserXIcon } from "assets/icons";
import { USER_TYPE } from "constants/appConstant";
import moment from "moment/moment";
import { AuthInfo } from "stores/slices/auth";
import { doUpdateCustomer } from "stores/slices/customer";
import { setHeaderTitle, setIsRefresh } from "stores/slices/layout";
import {
  // doGetMessageDetail,
  doGetMessageInReviewDetail,
  doGetMessageInReviewPage,
  doHideMessageSpam,
  doUpdateStatusMessage,
  numOfEls,
} from "stores/slices/message";

import AppButton from "components/button";
import ModalForm from "components/forms/components/modalForm";
import AppTable from "components/table";

import MessageDetailForm from "./messageDetailForm";
// const { confirm } = Modal;

const MessageInReviewPage = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const authInfo = useSelector(AuthInfo);
  const noOfElements = useSelector(numOfEls);
  const [isView, setIsview] = useState(false);
  // const [isRefresh, setIsRefresh] = useState(false);

  const [selectedMessageDetail, setSelectedMessageDetail] = useState({});
  const [searchParam, setSearchParam] = useState({
    pageNumber: 1,
    pageSize: 10,
    // ignore: false,
    // spam: true,
    workspaceId: authInfo.workspaceId,
    sortDirection: "DESC",
    sortField: "createdTime",
  });

  const [isOpenModalUpdate, setIsOpenModalUpdate] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState();
  const [columns, setColumns] = useState([]);
  const [isOpenModalBlock, setIsOpenModalBlock] = useState(false);
  const [isShowHideConfirm, setShowHideConfirm] = useState(false);
  const { customer } = authInfo;

  useEffect(() => {
    dispatch(setHeaderTitle(["messages", "reviewInbox"]));
  }, []);

  const handleViewDetail = async data => {
    const result = await dispatch(doGetMessageInReviewDetail(data.id));
    const { payload } = result;
    if (typeof payload === "object") {
      setSelectedMessageDetail({ ...payload, address: data.addressNumber });
      setIsview(true);
    }
  };

  const handleSubmitDownload = () => {
    setIsview(false);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  };

  const handleFilter = (selectedKeys, confirm) => {
    confirm();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    let newSearchParam = {
      // statuses: [STATUS_TYPE.ACTIVE],
      workspaceId: authInfo.workspaceId,
    };
    filters.phoneNumber &&
      (newSearchParam = {
        ...newSearchParam,
        customerNumber: filters.phoneNumber[0],
      });
    filters.workspaceName &&
      (newSearchParam = {
        ...newSearchParam,
        workspaceName: filters.workspaceName[0],
      });
    filters.customerName &&
      (newSearchParam = {
        ...newSearchParam,
        customerName: filters.customerName[0],
      });
    filters.customerNumber &&
      (newSearchParam = {
        ...newSearchParam,
        customerNumber: filters.customerNumber[0],
      });
    filters.message &&
      (newSearchParam = {
        ...newSearchParam,
        message: filters.message[0],
      });
    filters.lastMarkSpamTime &&
      filters.lastMarkSpamTime[0] &&
      (newSearchParam = {
        ...newSearchParam,
        fromDate: moment(filters.lastMarkSpamTime[0].toString()).format(
          "MM/DD/YYYY"
        ),
      });
    filters.lastMarkSpamTime &&
      filters.lastMarkSpamTime[1] &&
      (newSearchParam = {
        ...newSearchParam,
        toDate: moment(filters.lastMarkSpamTime[1].toString()).format(
          "MM/DD/YYYY"
        ),
      });
    if (sorter && sorter.columnKey && sorter.order) {
      newSearchParam = {
        ...newSearchParam,
        sortField: sorter.columnKey,
        sortDirection: sorter.order === "ascend" ? "ASC" : "DESC",
      };
    } else {
      newSearchParam = {
        ...newSearchParam,
        sortField: "createdTime",
        sortDirection: "DESC",
      };
    }

    newSearchParam = {
      ...newSearchParam,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParam(newSearchParam);
  };

  const handleFormatDateLocale = date => {
    const browserLocale = navigator.language;
    let dateLocale;
    if (date) {
      dateLocale = moment(date)
        .tz(customer?.timeZone ? customer?.timeZone : moment.tz.guess())
        .locale(browserLocale);
      return `${dateLocale.format("YYYY-MM-DD")} ${dateLocale.format("LT")}`;
    }
  };

  const showDeleteConfirm = data => {
    setSelectedMessage(data);
    setIsOpenModalUpdate(true);
  };
  const handleDelete = async () => {
    const request = {
      id: selectedMessage.id,
      data: {
        message: selectedMessage.message,
      },
    };
    if (selectedMessage.spam) {
      request.data.spam = false;
      request.data.read = false;
    }
    const result = await dispatch(doUpdateStatusMessage(request));
    setIsOpenModalUpdate(false);
    setSelectedMessage();
    setIsUpdating(false);
    if (result && result.payload && result.payload.data === "OK") {
      // console.log("noOfElements", noOfElements);
      if (searchParam.pageNumber > 1 && noOfElements === 1) {
        const newSearchParam = {
          ...searchParam,
          pageNumber: searchParam.pageNumber - 1,
        };
        setSearchParam(newSearchParam);
      }
      dispatch(setIsRefresh(uuid()));
    }
  };

  const handleHideMessage = async () => {
    const request = {
      id: selectedMessage.id,
      data: {
        message: selectedMessage.message,
        isHide: true,
      },
    };
    const result = await dispatch(doHideMessageSpam(request));
    setShowHideConfirm(false);
    setSelectedMessage();
    setIsUpdating(false);
    if (result && result.payload && result.payload.data === "OK") {
      // console.log("noOfElements", noOfElements);
      if (searchParam.pageNumber > 1 && noOfElements === 1) {
        const newSearchParam = {
          ...searchParam,
          pageNumber: searchParam.pageNumber - 1,
        };
        setSearchParam(newSearchParam);
      }
      dispatch(setIsRefresh(uuid()));
    }
  };

  const showHideConfirm = data => {
    setShowHideConfirm(true);
    setSelectedMessage(data);
  };

  const showBlockUserConfirm = data => {
    setIsOpenModalBlock(true);
    setSelectedMessage(data);
  };

  const handleBlockUser = async () => {
    setIsOpenModalBlock(false);
    const request = {
      isBlocked: true,
    };
    if (authInfo?.type === USER_TYPE.SUPER_ADMIN) {
      request.workspaceId = selectedMessage?.workspace?.id;
    }
    await dispatch(
      doUpdateCustomer({ id: selectedMessage?.customerId, data: request })
    );
    setSelectedMessage();
    dispatch(setIsRefresh(uuid()));
  };

  const actionOptionItems = record => {
    return [
      {
        key: "1",
        label: <span>{t("message.view")}</span>,
        icon: <EyeOutlined style={{ fontSize: 20 }} />,
        onClick: () => {
          handleViewDetail(record);
        },
      },
      {
        key: "2",
        label: <span>{t("message.hideMessage")}</span>,
        icon: <EyeInvisibleOutlined style={{ fontSize: 20 }} />,
        onClick: () => {
          showHideConfirm(record);
        },
      },
      {
        key: "3",
        label: <span>{t("message.markasNotSpam")}</span>,
        icon: <UnlockOutlined style={{ fontSize: 20 }} />,
        onClick: () => {
          showDeleteConfirm(record);
        },
      },

      {
        key: "4",
        danger: true,
        label: <span>{t("message.blockCustomer")}</span>,
        icon: <LockOutlined style={{ fontSize: 20 }} />,
        onClick: () => {
          showBlockUserConfirm(record);
        },
      },
    ];
  };

  useEffect(() => {
    let cols = [];
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      cols = [
        {
          title: t("message.workspace"),
          width: 40,
          dataIndex: "workspaceName",
          key: "workspaceName",
          isSearchable: true,
          searchPlaceholder:
            "Search by " + t("message.workspace").toString().toLowerCase(),
          sorter: true,
          sortDirections: ["ascend", "descend"],
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => <>{record?.workspace?.name}</>,
        },
        {
          title: t("message.phoneNumber"),
          width: 40,
          dataIndex: "phoneNumber",
          key: "phoneNumber",
          isSearchable: true,
          searchPlaceholder:
            "Search by" + t("message.phoneNumber").toString().toLowerCase(),
          sorter: true,
          sortDirections: ["ascend", "descend"],
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => <>{record?.phoneNumber}</>,
        },
        {
          title: t("message.customerName"),
          width: 40,
          dataIndex: "customerName",
          key: "customerName",
          isSearchable: true,
          sorter: true,
          sortDirections: ["ascend", "descend"],
          searchPlaceholder:
            "Search by " + t("message.customerName").toString().toLowerCase(),
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => {
            if (record.custFirstName || record.custLastName) {
              return (
                <>{`${record.custFirstName ? record.custFirstName : ""} ${
                  record.custLastName ? record.custLastName : ""
                }`}</>
              );
            } else {
              return (
                <>{`${record.fromUserEmail ? record.fromUserEmail : ""}`}</>
              );
            }
          },
        },
        {
          title: t("message.message"),
          width: 60,
          dataIndex: "message",
          key: "message",
          sorter: true,
          sortDirections: ["ascend", "descend"],
          isSearchable: true,
          searchPlaceholder:
            "Search by " + t("message.message").toString().toLowerCase(),
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => (
            <Tooltip title={record.message}>{record.message}</Tooltip>
          ),
        },
        {
          title: t("message.markDateAndTime"),
          width: 50,
          dataIndex: "lastMarkSpamTime",
          key: "lastMarkSpamTime",
          isFilterable: true,
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => (
            <>
              {record.lastMarkSpamTime
                ? handleFormatDateLocale(record.lastMarkSpamTime)
                : ""}
            </>
          ),
        },

        {
          title: t("message.status"),
          width: 20,
          dataIndex: "status",
          key: "status",
          render: (_, record) => (
            <Tag color={record.spam ? "#FDF8EA" : ""} bordered={false}>
              <div
                style={{
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  color: record.spam ? "#C48F07" : "",
                  padding: 5,
                }}
              >
                {record.spam ? (
                  <>
                    <UserXIcon color={"#C48F07"} />
                    <span style={{ marginLeft: 8 }}>{t(`message.SPAM`)}</span>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Tag>
          ),
        },
        {
          title: t("message.actions"),
          width: 25,
          key: "operation",
          render: (_, record) => {
            return (
              <>
                <Space size="middle">
                  <Dropdown
                    trigger={["click"]}
                    menu={{
                      items: actionOptionItems(record),
                    }}
                    placement="bottomRight"
                  >
                    <Button type="text" shape="circle" size="middle">
                      <DotVerticalIcon />
                    </Button>
                  </Dropdown>
                </Space>
              </>
            );
          },
        },
      ];
    } else {
      cols = [
        {
          title: t("message.phoneNumber"),
          width: 40,
          dataIndex: "phoneNumber",
          key: "phoneNumber",
          isSearchable: true,
          searchPlaceholder:
            "Search by" + t("message.phoneNumber").toString().toLowerCase(),
          sorter: true,
          sortDirections: ["ascend", "descend"],
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => <>{record?.phoneNumber}</>,
        },
        {
          title: t("message.customerName"),
          width: 60,
          dataIndex: "customerName",
          key: "customerName",
          isSearchable: true,
          sorter: true,
          sortDirections: ["ascend", "descend"],
          searchPlaceholder:
            "Search by " + t("message.customerName").toString().toLowerCase(),
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => {
            if (record.custFirstName || record.custLastName) {
              return (
                <>{`${record.custFirstName ? record.custFirstName : ""} ${
                  record.custLastName ? record.custLastName : ""
                }`}</>
              );
            } else {
              return (
                <>{`${record.fromUserEmail ? record.fromUserEmail : ""}`}</>
              );
            }
          },
        },
        {
          title: t("message.markDateAndTime"),
          width: 30,
          dataIndex: "lastMarkSpamTime",
          key: "lastMarkSpamTime",
          isFilterable: true,
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => (
            <>
              {record.lastMarkSpamTime
                ? handleFormatDateLocale(record.lastMarkSpamTime)
                : ""}
            </>
          ),
        },
        {
          title: t("message.message"),
          width: 60,
          dataIndex: "message",
          key: "message",
          sorter: true,
          sortDirections: ["ascend", "descend"],
          isSearchable: true,
          searchPlaceholder:
            "Search by " + t("message.message").toString().toLowerCase(),
          ellipsis: {
            showTitle: false,
          },
          render: (_, record) => (
            <Tooltip title={record.message}>{record.message}</Tooltip>
          ),
        },
        {
          title: t("message.status"),
          width: 20,
          dataIndex: "status",
          key: "status",
          render: (_, record) => (
            <Tag color={record.spam ? "#FDF8EA" : ""} bordered={false}>
              <div
                style={{
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  color: record.spam ? "#C48F07" : "",
                  padding: 5,
                }}
              >
                {record.spam ? (
                  <>
                    <UserXIcon color={"#C48F07"} />
                    <span style={{ marginLeft: 8 }}>{t(`message.SPAM`)}</span>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Tag>
          ),
        },
        {
          title: t("message.actions"),
          width: 20,
          key: "operation",
          render: (_, record) => {
            return (
              <>
                <Space size="middle">
                  <Dropdown
                    trigger={["click"]}
                    menu={{
                      items: actionOptionItems(record),
                    }}
                    placement="bottomRight"
                  >
                    <Button type="text" shape="circle" size="middle">
                      <DotVerticalIcon />
                    </Button>
                  </Dropdown>
                </Space>
              </>
            );
          },
        },
      ];
    }
    setColumns(cols);
  }, []);

  const handleTitleUpdateStatus = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("message.updateMessage")}
        </span>
      </div>
    );
  };

  const handleTitleBlockUser = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("message.blockCustomer")}
        </span>
      </div>
    );
  };

  const handleTitleHideMessage = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("message.hideMessage")}
        </span>
      </div>
    );
  };

  return (
    <div>
      <div style={{ witdh: "100%" }}>
        <AppTable
          api={doGetMessageInReviewPage(searchParam)}
          columns={columns}
          searchParam={searchParam}
          handleSearch={handleSearch}
          handleFilter={handleFilter}
          handleTableChange={handleTableChange}
          setSearchParam={setSearchParam}
        />
      </div>
      <ModalForm
        title={t("message.messageDetail")}
        isOpen={isView}
        onCancel={() => {
          setIsview(false);
        }}
        customWidth={600}
        labelSubmit={t("button.download")}
        onSubmit={handleSubmitDownload}
        footer={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        <MessageDetailForm
          messageDetail={selectedMessageDetail}
          isView={isView}
          isRecipient={false}
          onCancel={() => {
            setIsview(false);
          }}
        />
      </ModalForm>
      <ModalForm
        isOpen={isOpenModalUpdate}
        type="confirm"
        title={handleTitleUpdateStatus()}
        onCancel={() => {
          setIsOpenModalUpdate(false);
        }}
        danger={true}
        maskClosable={false}
        footer={[
          <AppButton
            key="button-no1"
            label={t("button.no")}
            color={"grey"}
            loading={isUpdating}
            disabled={isUpdating}
            htmlType="button"
            onClick={() => {
              setIsOpenModalUpdate(false);
            }}
          />,
          <AppButton
            key="button-yes"
            type="primary"
            color={"blue"}
            label={t("button.yes")}
            loading={isUpdating}
            disabled={isUpdating}
            onClick={() => {
              setIsUpdating(true);
              handleDelete();
            }}
          />,
        ]}
      >
        <div style={{ height: 50, marginLeft: 35, fontSize: 14 }}>
          {t("text.unlockMessage")}
        </div>
      </ModalForm>
      <ModalForm
        isOpen={isShowHideConfirm}
        type="confirm"
        title={handleTitleHideMessage()}
        danger={true}
        maskClosable={false}
        onCancel={() => {
          setShowHideConfirm(false);
        }}
        footer={[
          <AppButton
            key="button-no"
            label={t("button.no")}
            color={"grey"}
            loading={isUpdating}
            disabled={isUpdating}
            htmlType="button"
            onClick={() => {
              setShowHideConfirm(false);
            }}
          />,
          <AppButton
            key="button-yes"
            type="primary"
            color={"blue"}
            label={t("button.yes")}
            loading={isUpdating}
            disabled={isUpdating}
            onClick={() => {
              handleHideMessage();
            }}
          />,
        ]}
      >
        <div
          style={{
            width: "100%",
            marginLeft: 35,
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          {t("message.confirmHideMessage")}
        </div>
      </ModalForm>
      <ModalForm
        isOpen={isOpenModalBlock}
        type="confirm"
        title={handleTitleBlockUser()}
        danger={true}
        maskClosable={false}
        onCancel={() => {
          setIsOpenModalBlock(false);
        }}
        footer={[
          <AppButton
            key="button-no"
            label={t("button.no")}
            color={"grey"}
            loading={isUpdating}
            disabled={isUpdating}
            htmlType="button"
            onClick={() => {
              setIsOpenModalBlock(false);
            }}
          />,
          <AppButton
            key="button-yes"
            type="primary"
            color={"blue"}
            label={t("button.yes")}
            loading={isUpdating}
            disabled={isUpdating}
            onClick={() => {
              handleBlockUser();
            }}
          />,
        ]}
      >
        {t("inbox.chatList.blockUserMsg")}
      </ModalForm>
    </div>
  );
};

export default MessageInReviewPage;
